import type { ReactNode } from 'react';
import { Icon } from './Icon';
import styles from './Accordion.module.scss';

interface Props {
  title: ReactNode;
  defaultOpen?: boolean;
  children: ReactNode;
  className?: string;
  /** Optional DOM id on the <details>, so other controls can open/scroll to it. */
  id?: string;
}

export function Accordion({
  title,
  defaultOpen = false,
  children,
  className,
  id,
}: Props): JSX.Element {
  return (
    <details
      id={id}
      className={[styles.acc, className ?? ''].filter(Boolean).join(' ')}
      open={defaultOpen}
    >
      <summary className={styles.summary}>
        <span className={styles.title}>{title}</span>
        <Icon name="plus" size={18} className={styles.iconPlus} aria-hidden />
        <Icon name="minus" size={18} className={styles.iconMinus} aria-hidden />
      </summary>
      <div className={styles.body}>{children}</div>
    </details>
  );
}
